import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { CancelEmailChangeConfirmationModalComponent } from './cancel-email-change-confirmation-modal.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [CancelEmailChangeConfirmationModalComponent],
})
export class CancelEmailChangeConfirmationModalModule {}
